import JobProApi from '../../../dependencies/JobProApi';
import { updateEvent, updatePurchaseOrder } from '../../calendar';
import { FETCH_STANDARD_CREWS_COMPLETE } from '../../standardCrews';

// Action types
const EDIT_CREW_MODAL_UPDATE = 'EDIT_CREW_MODAL_UPDATE';
const TOGGLE_CREW_MODAL = 'TOGGLE_CREW_MODAL';

const DEFAULT_STATE = {
  crew: {
    resources: []
  },
  equipment: [],
  events: [],
  loading: false,
  resources: [],
  show: false,
  standardCrews: []
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case EDIT_CREW_MODAL_UPDATE:
      return {
        ...state,
        crew: {
          ...state.crew,
          ...payload
        }
      }
    case FETCH_STANDARD_CREWS_COMPLETE:
      return {
        ...state,
        standardCrews: payload.crews
      };
    case TOGGLE_CREW_MODAL:
      return payload ? {
        ...state,
        ...payload,
        show: !!payload
      } : DEFAULT_STATE;
    default:
      return state;
  }
}

// Action creators
export const editCrewModalUpdate = (changes) => ({
  type: EDIT_CREW_MODAL_UPDATE,
  payload: changes
});

export const toggleCrewModal = (crew, events) => (dispatch) => {
  if (!crew && !events) {
    dispatch({
      type: TOGGLE_CREW_MODAL,
      payload: null
    });
    return;
  }

  dispatch({
    type: TOGGLE_CREW_MODAL,
    payload: {
      crew,
      events,
      loading: true
    }
  });

  const equipmentPromise = JobProApi.equipment.query(
    {
      schedulable: true,
      'status!': 'Inactive',
    },
    {
      fields: 'id,color,name',
      limit: 9999,
    }
  );

  const resourcesPromise = JobProApi.resources.query({
    isActive: true,
    isJobAssignee: true
  }, {
      fields: 'id,employeeId,firstName,lastName'
    });

  Promise.all([equipmentPromise, resourcesPromise]).then(([equipment, resources]) => {
    dispatch({
      type: TOGGLE_CREW_MODAL,
      payload: {
        crew,
        equipment,
        events,
        loading: false,
        resources
      }
    });
  });
};

export const editCrewModalConfirm = () => (dispatch, getState) => {
  const { crew, events } = getState().modals.crewModal;
  events.forEach((e) => {
    const crewPayload = crew ? {
        equipment: crew.equipment ? { id: crew.equipment.id } : null,
        resources: crew.resources.map(({ resource, resourcePercentage }) => ({
          resource: { id: resource.id },
          resourcePercentage
        }))
      } : null;
    if (e.purchaseOrder) {
      dispatch(updatePurchaseOrder(e.purchaseOrder.id, {
        crew: crewPayload
      }));
    } else {
      dispatch(updateEvent(e.id, {
        crew: crewPayload
      }));
    }
  });
  dispatch(toggleCrewModal());
};
